import { ColDef } from "@ag-grid-community/core";
import { createSelector } from "reselect";

import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";

import { RootState } from "@app/store/rootReducer";
import { RouteFieldName } from "@app/util/fieldModel/RouteFieldModel";

import COLUMN_WIDTHS from "./columnWidths";

const getListViewSubState = (state: RootState) => state.scene.route.listView;

export const getListViewState = createSelector(getListViewSubState, ({ viewState }) => viewState);

export const getListViewTotalFilteredRecordsCount = createSelector(
  getListViewSubState,
  ({ totalFilteredRecords }) => totalFilteredRecords
);

export const getListViewTotalRecordsCount = createSelector(
  getListViewSubState,
  ({ totalRecords }) => totalRecords
);

export const isListViewInitialized = createSelector(
  getListViewSubState,
  ({ initialized }) => initialized
);

export const isListViewLoading = createSelector(getListViewSubState, ({ loading }) => loading);

export const getGridColumnDefs = createSelector(getListViewState, ({ columns }) => {
  return columns
    .filter(
      ({ field }) =>
        (field.isReadable || field.isSystemRequired) &&
        // Visibility comes from the field model, not from the persisted `visible`.
        // The peer grids pass `hide: !visible` instead, which this grid must not do:
        // no route field had VISIBLE_BY_DEFAULT before this list moved to AgGrid, so
        // everyone who opened the old table has `visible: false` stored for every
        // column, and honoring it would render an empty grid. There is no column
        // chooser here, so the stored flag can never be corrected by the user.
        field.hasAnyFeature(FieldFeature.VISIBLE_BY_DEFAULT, FieldFeature.ALWAYS_VISIBLE)
    )
    .map<ColDef>(({ field, pinned, width }) => ({
      ...field.gridProperties(),
      pinned,
      // a persisted resize wins over the first-run default
      width: width ?? COLUMN_WIDTHS[field.name as RouteFieldName],
    }));
});
